export async function copyText(text) {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return;
    }
  } catch { console.warn('Clipboard API denied; trying selection-based copy.'); }
  const previous = document.activeElement;
  const input = document.createElement('textarea');
  input.value = text;
  input.setAttribute('readonly', '');
  input.setAttribute('aria-hidden', 'true');
  input.setAttribute('data-testid', 'clipboard-temporary-selection');
  input.tabIndex = -1;
  Object.assign(input.style, { position: 'fixed', width: '1px', height: '1px', top: '0', left: '0', opacity: '0', pointerEvents: 'none' });
  document.body.appendChild(input);
  try {
    input.focus({ preventScroll: true }); input.select(); input.setSelectionRange(0, text.length);
    if (!document.execCommand('copy')) throw new Error('Clipboard unavailable');
  } finally { input.remove(); previous?.focus?.({ preventScroll: true }); }
}